import * as React from 'react'
import { hot } from 'react-hot-loader'
import { syncHistoryWithStore } from 'mobx-react-router'
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import * as styles from './index.scss'
import { MainRoutes } from './Routes/index'
import AlertPopup from '@components/Popup/AlertPopup'
import * as store from '../store'

const browserHistory = createBrowserHistory()
const history = syncHistoryWithStore(browserHistory, store.routerStore)

class App extends React.Component<{}> {
    render() {
        return (
            <Router history={history}>
                <div className={styles.appWrapper}>
                    <MainRoutes />
                    <AlertPopup />
                </div>
            </Router>
        )
    }
}

export default hot(module)(App)
